export default __webpack_public_path__ + "static/media/whatsapp.2b632538.svg";